export function VerticalSpacer(props: { height: number }): JSX.Element {
  return <div style={{ height: `${props.height}px` }} />;
}

export function HorizontalSpacer(props: { width: number }): JSX.Element {
  return <div style={{ width: `${props.width}px` }} />;
}
